import axios from 'axios';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const MakePayment = () => {
  const { land: product } = useLocation().state || {};

  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validatePhone = (phone) => {
    const pattern = /^2547\d{8}$/;
    return pattern.test(phone);
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!validatePhone(phone)) {
      setMessage('❌ Invalid phone format. Use 2547XXXXXXXX.');
      return;
    }

    try {
      setIsSubmitting(true);
      setMessage('⏳ Please wait as we process your request...');

      const data = new FormData();
      data.append('phone', phone);
      data.append('amount', product.product_cost);

      await axios.post(
        'https://mnkymn9n.pythonanywhere.com/api/mpesa_payment',
        data
      );

      setMessage('✅ Please complete payment on your phone.');
    } catch (error) {
      console.error(error);
      setMessage('❌ Payment failed. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='container mt-5'>
      <Link to='/' className='btn btn-outline-primary mb-3'>
        ← Back to Products
      </Link>

      <h1 className='text-center mb-4'>Make Payment - Lipa Na MPESA</h1>

      <div className='row justify-content-center'>
        <div className='col-md-6 card shadow p-4'>
          {product?.product_photo && (
            <img
              src={`https://mnkymn9n.pythonanywhere.com/static/images/${product.product_photo}`}
              alt={product.product_name}
              className='img-fluid mb-3 rounded'
            />
          )}

          <h4 className='text-info'>{product.product_name}</h4>
          <p>{product.product_description}</p>
          <p className='text-warning fw-bold'>Ksh {product.product_cost}</p>

          <form onSubmit={submit}>
            <input
              type='text'
              className='form-control mb-3'
              placeholder='Enter phone (2547XXXXXXXX)'
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              disabled={isSubmitting}
            />

            <button className='btn btn-success w-100' type='submit' disabled={isSubmitting}>
              {isSubmitting ? 'Processing...' : 'Make Payment'}
            </button>
          </form>

          {message && (
            <div className='alert alert-info mt-3 text-center'>{message}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MakePayment;
